import React, { Fragment, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { Col, Container, Form, FormGroup, Input, Label, Row } from "reactstrap";
import { Btn, H4, H6, P, Image } from "../../../AbstractElements";
import Logo from "../../../assets/images/logo/logo.png";
import logoDark from "../../../assets/images/logo/logo_dark.png";
import { useForm } from "react-hook-form";
import { ForgetPassword, ForgetVerfiyOtp, ForgetChangePassword } from "../../../apiController";
import {toast }from 'react-toastify'

const ForgetPwd = ({ logoClassMain }) => {

  const navigate = useNavigate()
  const {
    register,
    handleSubmit,
    watch,
    setValue,
    formState: { errors },
  } = useForm();
  const [togglePassword, setTogglePassword] = useState(false);
  const [isFormSubmitted, setIsFormSubmitted] = useState(false);
  const [currentStep, setCurrentStep] = useState(1);
  const newPassword = watch("newPassword");
  const retypePassword = watch("retypePassword");

  const onPhoneSubmit = (data) => {
    console.log("Phone Number:", data);
    const formData = {
      "phone":data.mobileNumber}
      forgetGenerateOTP(formData)
    
  };

  const onOtpSubmit = (data) => {
    console.log("OTP:", data);
    const formData = {
      otp: data.otp
    }
    forgetVerfiyOTP(formData)
    
  };

  const onPasswordSubmit = (data) => {
    console.log("Password:", data);

    const formData = {
      password: data.newPassword,
      confirm_password: data.retypePassword
    }

    forgetChangePassword(formData)
  };

  const forgetGenerateOTP = async (forget) => {
    try {
        const response = await ForgetPassword(JSON.stringify(forget));
        console.log(response);

        if (response.status === true) {
            toast.success(response.message, {
                className: 'foo_bar_log_Success'
            });
            ;
        } else {
            toast.error(response.message, {
                className: 'foo_bar_log_error'
            });
        }
    } catch (error) {
        console.error("Error occurred:", error);
        toast.error("An unexpected error occurred. Please try again.", {
            className: 'foo_bar_log_error'
        });
    } finally {
      setCurrentStep(2); 
    }
};
  const forgetVerfiyOTP = async (forget) => {
    try {
        const response = await ForgetVerfiyOtp(JSON.stringify(forget));
        console.log(response);

        if (response.status === true) {
            toast.success(response.message, {
                className: 'foo_bar_log_Success'
            });
            ;
        } else {
            toast.error(response.message, {
                className: 'foo_bar_log_error'
            });
        }
    } catch (error) {
        console.error("Error occurred:", error);
        toast.error("An unexpected error occurred. Please try again.", {
            className: 'foo_bar_log_error'
        });
    } finally {
      setCurrentStep(3);
    }
};
  const forgetChangePassword = async (forget) => {
    try {
        const response = await ForgetChangePassword(JSON.stringify(forget));
        console.log(response);

        if (response.status === true) {
            toast.success(response.message, {
                className: 'foo_bar_log_Success'
            });
            ;
        } else {
            toast.error(response.message, {
                className: 'foo_bar_log_error'
            });
        }
    } catch (error) {
        console.error("Error occurred:", error);
        toast.error("An unexpected error occurred. Please try again.", {
            className: 'foo_bar_log_error'
        });
    } finally {
      navigate(`${process.env.PUBLIC_URL}/login`)
    }
};


  // const onSubmit = (data) => {
  //   console.log(data);
  //   // Handle form submission logic
  // };

  return (
    <Fragment>
      <section>
        <Container className="p-0 login-page" fluid={true}>
          <Row className="m-0">
            <Col className="p-0">
              <div className="login-card">
                <div>
                  {/* <div>
            <Link className={`logo ${logoClassMain ? logoClassMain : ''}`} to={process.env.PUBLIC_URL}>
              <Image attrImage={{ className: 'img-fluid w-50 for-light', src: logoWhite, alt: 'loginpage' }} />
            </Link>
          </div> */}
                  {/* <div>
                    <Link className={`logo ${logoClassMain ? logoClassMain : ''}`} to={process.env.PUBLIC_URL}>
                      <Image attrImage={{ className: 'img-fluid for-light', src: logoWhite, alt: 'looginpage' }} />
                      <Image attrImage={{ className: 'img-fluid for-dark', src: logoDark, alt: 'looginpage' }} />
                    </Link>
                  </div> */}
                  <div className="login-main">
                    <Form
                      className="theme-form login-form"
                      onSubmit={handleSubmit(
                        currentStep === 1
                          ? onPhoneSubmit
                          : currentStep === 2
                          ? onOtpSubmit
                          : onPasswordSubmit
                      )}
                    >
                      <div className="d-flex justify-content-center">
                        <Image
                          attrImage={{
                            className: " img-fluid w-50 for-light",
                            src: Logo,
                            alt: "looginpage",
                          }}
                        />
                      </div>
                      <H4>
                        {currentStep === 1
                          ? "Enter Your Mobile Number"
                          : currentStep === 2
                          ? "Enter OTP"
                          : "Create Your Password"}
                      </H4>

                      {/* Step 1: Phone Number */}
                      {currentStep === 1 && (
                        <FormGroup>
                          <Label className="m-0 col-form-label">
                            Enter Your Mobile Number
                          </Label>
                          <Row>
                            <Col xs="4" sm="3">
                              <Input
                                className="form-control"
                                type="text"
                                defaultValue="+ 91"
                                readOnly
                              />
                            </Col>
                            <Col xs="8" sm="9">
                              <input
                                className="form-control"
                                type="number"
                                name="mobileNumber"
                                {...register("mobileNumber", {
                                  required: false,
                                })}
                                placeholder="000-000-0000"
                              />
                              {errors.mobileNumber && (
                                <span className="text-danger">
                                  Mobile number is required
                                </span>
                              )}
                            </Col>
                          </Row>
                        </FormGroup>
                      )}

                      {/* Step 2: OTP */}
                      {currentStep === 2 && (
                        <FormGroup>
                          <Label>Enter OTP</Label>
                          <Row>
                            {/* {Array.from({ length: 1 }).map((_, index) => ( */}
                              <Col>
                                <input
                                  className="form-control text-center opt-text"
                                  type="text"
                                  {...register('otp', {
                                    required: true,
                                    maxLength: 6,
                                  })}
                                  placeholder="Enter Your OTP"
                                />
                              </Col>
                            {/* ))} */}
                          </Row>
                          {errors.otp && (
                            <span className="text-danger">OTP is required</span>
                          )}
                        </FormGroup>
                      )}

                      {/* Step 3: Passwords */}
                      {currentStep === 3 && (
                        <>
                          <H6 attrH6={{ className: "mt-4" }}>
                            Create Your Password
                          </H6>
                          <FormGroup className="position-relative">
                            <Label className="col-form-label m-0">
                              New Password
                            </Label>
                            <div className="position-relative">
                              <input
                                className="form-control"
                                type={togglePassword ? "text" : "password"}
                                {...register("newPassword", { required: true })}
                                placeholder="*********"
                              />
                              <div
                                className="show-hide"
                                onClick={() =>
                                  setTogglePassword(!togglePassword)
                                }
                              >
                                <span
                                  className={togglePassword ? "" : "show"}
                                ></span>
                              </div>
                            </div>
                            {errors.newPassword && (
                              <span className="text-danger">
                                Password is required
                              </span>
                            )}
                          </FormGroup>
                          <FormGroup>
                            <Label className="col-form-label m-0">
                              Retype Password
                            </Label>
                            <div className="position-relative">
                            <input
                              className="form-control"
                              type={togglePassword ? "text" : "password"}
                              {...register("retypePassword", {
                                required: true,
                                validate: (value) =>
                                  value === newPassword ||
                                  "Passwords do not match",
                              })}
                              placeholder="*********"
                            />
                            <div
                                className="show-hide"
                                onClick={() =>
                                  setTogglePassword(!togglePassword)
                                }
                              >
                                <span
                                  className={togglePassword ? "" : "show"}
                                ></span>
                              </div>
                              </div>
                            {errors.retypePassword && (
                              <span className="text-danger">
                                {errors.retypePassword.message}
                              </span>
                            )}
                          </FormGroup>
                        </>
                      )}

                      <FormGroup className="text-end">
                        <Btn
                          attrBtn={{
                            className: "btn-block",
                            color: "primary",
                            type: "submit",
                          }}
                        >
                          {currentStep === 1
                            ? "Send"
                            : currentStep === 2
                            ? "Verify OTP"
                            : "Done"}
                        </Btn>
                      </FormGroup>

                      {currentStep < 3 && (
                        <P attrPara={{ className: "text-start" }}>
                          Already have a password?
                          <Link
                            className="ms-2"
                            to={`${process.env.PUBLIC_URL}/login`}
                          >
                            Sign in
                          </Link>
                        </P>
                      )}
                    </Form>
                  </div>
                </div>
              </div>
            </Col>
          </Row>
        </Container>
      </section>
    </Fragment>
  );
};

export default ForgetPwd;
